import React from 'react';

import { STATIC_ROOT } from '../../../../constants';

import SvgComponent from '../../../SvgComponent';

import './CardsPictoStyle.scss';

const CardsPicto = () => {
    return (
        <div id="cards-picto-wrapper">
            <SvgComponent src={`${STATIC_ROOT}/payment/visa.svg`} height={25} />
            <SvgComponent src={`${STATIC_ROOT}/payment/mastercard.svg`} height={25} />
            <SvgComponent src={`${STATIC_ROOT}/payment/cb2.svg`} height={25} />
        </div>
    );
};

export default CardsPicto;



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/payment-choice/CardsPicto.js